(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('localizerConfig', function() {
        return factory(root);
      });
  } else {
    root.localizerConfig = factory(root);
  }
})(this, function(root) {

	var oneYear = 365*24*60*60*1000; // a year in milliseconds
	var sixHundredDays = 600*24*60*60*1000 // 600 days in milliseconds
	var session = 0;
	//var oneHour = 60*60*1000; // an hour in milliseconds
	var fiveMinutes = 5*60*1000;
	// var NEW_KEY_WORKFLOW = 'W';
	// var NEW_KEY_THD_INTERNAL= 'I';
	// var NEW_KEY_THD_FORCE_LOC = 'F';
	// var NEW_KEY_THD_STRFINDERZIP = 'Z';
	// var NEW_KEY_THD_LOCSTORE = 'L';
	// var NEW_KEY_THD_STORE_HOURS = 'H';
	// var NEW_KEY_THD_STORE_HOURS_EXPIRY = 'E';

	var CONFIG = {
		DEV: {
			LOCALIZATION_API_HOST: '//localization-dev.thdws.com',
			HOST: '//hd-qa71.homedepotdev.com',
			COOKIE_DOMAIN: '.hd-qa71.homedepotdev.com'
		},
		STAGE: {
			LOCALIZATION_API_HOST: '//localization-stage.thdws.com',
			HOST: '//hd-qa74.homedepotdev.com',
			COOKIE_DOMAIN: '.hd-qa74.homedepotdev.com'
		},
		PROD: {
			LOCALIZATION_API_HOST: '//localization.thdws.com',
			HOST: '//www.homedepot.com',
			COOKIE_DOMAIN: '.homedepot.com'
		},
		SERVICES: {
			LOCALIZATION_SERVICE: '/LocalizationService/v1/localstore',
			STORE_SEARCH_SERVICE: '/StoreSearchServices/v2/storesearch'
		}
	};

	var localizerConfig = {
				storageConfig : {
					GPS_STATUS: { 
						storage : 'session', 
						expiry: undefined 
					},
					localizationMethod: { 
						storage : 'local', 	
						expiry: undefined 
					},
					HTTP_URL: { 
						storage : 'http', 			 
						expiry: undefined 
					},
					THD_INSTORE: { 
						storage : 'cookie', 
						expiry: session	 
					},
					IN_STORE_USER_NUMBER: {
						storage : 'cookie', 
						expiry: fiveMinutes
					},
					DELIVERY_ZIP: { 
						storage : 'cookie', 
						expiry: oneYear	 
					},
					DELIVERY_ZIP_TYPE: { 
						storage : 'cookie', 
						expiry: oneYear	
					},
					THD_LOCALIZER: 	{ 
						storage: 'cookie',
						expiry: ''
					},
					THD_CA_USER: {
						 storage : 'cookie', 
						 expiry: sixHundredDays 
					},
					THD_AUTOLOCINTERCEPT: { 
						storage : 'cookie', 
						expiry: sixHundredDays 
					},
					IN_STORE_API_SESSION: {
						storage : 'cookie', 
						expiry: fiveMinutes 						
					},
					DEFAULT: {
						storage : 'cookie', 
						expiry: session 						
					},
					get: function(key) {
						return this[key] ? this[key] : this['DEFAULT'];
					}
				},
				getConfig: function() {
					var localConfig = {
						service: CONFIG.SERVICES.LOCALIZATION_SERVICE,
						storeSearchService: CONFIG.SERVICES.STORE_SEARCH_SERVICE,
						localizationApiHost: CONFIG.PROD.LOCALIZATION_API_HOST,
						cookieDomain: CONFIG.PROD.COOKIE_DOMAIN,
						host: CONFIG.PROD.HOST
					};
					if (window.location.href.indexOf('hd-qa71.homedepotdev') !== -1) {
						localConfig.localizationApiHost = CONFIG.DEV.LOCALIZATION_API_HOST; 
						localConfig.cookieDomain = CONFIG.DEV.COOKIE_DOMAIN;
						localConfig.host = CONFIG.DEV.HOST;
					}
    				if (window.location.href.indexOf('hd-qa74.homedepotdev') !== -1) {
						localConfig.localizationApiHost = CONFIG.STAGE.LOCALIZATION_API_HOST;
						localConfig.cookieDomain = CONFIG.STAGE.COOKIE_DOMAIN;
						localConfig.host = CONFIG.STAGE.HOST;
					}
				
					return localConfig;
				}//,
				// getNewCookieKey: function(key){
				// 	var newKey = {
				// 	  WORKFLOW : NEW_KEY_WORKFLOW,
				// 	  THD_INTERNAL: NEW_KEY_THD_INTERNAL,
				// 	  THD_FORCE_LOC : NEW_KEY_THD_FORCE_LOC,
				// 	  THD_STRFINDERZIP : NEW_KEY_THD_STRFINDERZIP,
				// 	  THD_LOCSTORE : NEW_KEY_THD_LOCSTORE,
				// 	  THD_STORE_HOURS : NEW_KEY_THD_STORE_HOURS,
				// 	  THD_STORE_HOURS_EXPIRY : NEW_KEY_THD_STORE_HOURS_EXPIRY
				// 	}
				// 	return newKey[key] ? newKey[key] : key;
				// }
			}
	return localizerConfig;
})



//////////////////
// WEBPACK FOOTER
// ./src/localizerConfig.js
// module id = 3
// module chunks = 0